import { render, staticRenderFns } from "./CategoryTreeItem.vue?vue&type=template&id=52c6d292&scoped=true"
import script from "./CategoryTreeItem.vue?vue&type=script&lang=js"
export * from "./CategoryTreeItem.vue?vue&type=script&lang=js"
import style0 from "./CategoryTreeItem.vue?vue&type=style&index=0&id=52c6d292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c6d292",
  null
  
)

export default component.exports